<div class="inner-page-header" style="margin-bottom: var(--mb-60)">
  <h1>{{ "partner-depts.dept-onboarding" | translate }}</h1>
</div>
<div class="main-section">
  <div class="container mb-60">
    <div class="heading mb">
      <h2>{{ "partner-depts.how-it-works" | translate }}</h2>
    </div>
    <div class="row">
      <ng-container *ngFor="let item of howItWorksConfig; let i = index">
        <div
          class="col-md-2 col-sm-2 how-work-col position-relative"
          [ngClass]="{ 'cursor-pointer': item.url }"
          (click)="redirectToEndpoint(item.url)"
        >
          <img
            src="https://media.umangapp.in/cdn/landing/theme/icons/arrow-right-lg.svg"
            alt=""
            class="how-work-arrow"
            loading="lazy"
            fetchpriority="high"
            
          />
          <div class="how-work-card">
            <div class="how-work-card__img">
              <img 
                imgFallback 
                [src]="item.img" 
                alt="{{ item.title }}" 
                loading="lazy"
                fetchpriority="high"
                />
            </div>
            <div class="how-work-card__content">
              <p>{{ item.title | translate }}</p>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="container mb-60">
    <div class="row flow">
      <div class="col-md-5 flow__left">
        <div class="heading">
          <h2>{{ "partner-depts.head" | translate }}</h2>
          <p>
            {{ "partner-depts.desc" | translate }}
          </p>
          <button class="btn btn-primary" (click)="openPartnersDialog()">
            {{ "buttons.view-more" | translate }}
          </button>
        </div>
      </div>
      <div class="col-md-7 flow__right">
        <picture>
          <source
            srcset="https://media.umangapp.in/cdn/landing/theme/flow.webp"
          />
          <img
            imgFallback
            loading="lazy"
            fetchpriority="high"
            
            src="https://media.umangapp.in/cdn/landing/theme/flow.jpg"
            alt="flow"
            class="resp-image"
            width="1274"
            height="1204"
          />
        </picture>
      </div>
    </div>
  </div>

  <div class="container mb-60 sm-mb-0">
    <div class="heading mb">
      <h2>{{ "pages.our-partners" | translate }}</h2>
    </div>
    <div class="row partner-card-row">
      <div
        class="col-md-2 col-6 partner-card-col"
        *ngFor="let item of partnersConfig"
      >
        <div class="partner-card">
          <picture>
            <source srcset="{{item?.imgWebp}}" />
            <img
              imgFallback
              loading="lazy"
              fetchpriority="high"
              
              [src]="item?.img"
              alt="{{ item?.alt }}"
              class="resp-image"
              width="175"
              height="110"
            />
          </picture>
        </div>
      </div>
      <div class="col-md-2 col-6 partner-card-col">
        <div
          class="partner-card partner-card--more cursor-pointer"
          routerLink="/services"
        >
          <picture>
            <source
              srcset="
                https://media.umangapp.in/cdn/landing/theme/partners/more.webp
              "
            />
            <img
              imgFallback
              loading="lazy"
              fetchpriority="high"
              
              src="https://media.umangapp.in/cdn/landing/theme/partners/more.jpg"
              class="resp-image bright"
              width="175"
              height="110"
            />
          </picture>
          <p>{{ "partner-depts.and-many-more" | translate }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
